const { id, log } = require("../std/index")


//
// Currency Chooser
//
// Basically an instance of Chosen with some redirect behaviour
//

module.exports = class CurrencyChooser {
  constructor($host, config) {
    const $select = $('select', $host);

    $select.on('change', () => $host[0].submit());

    $select.chosen({
      disable_search_threshold: 100
    });
  }
};
